export interface User {
    firstName: string;
    lastName: string;
    tenantId: string;
    userType?: string;
    username?: string;
    permissions: string[];
}

export class CurrentUser implements User {
    firstName: string;
    lastName: string;
    tenantId: string;
    userType?: string;
    username?: string;
    permissions: string[];

    constructor(user: User) {
        this.lastName = user.lastName;
        this.tenantId = user.tenantId;
        this.firstName = user.firstName;
        this.userType = user.userType;
        this.username = user.username;
        this.permissions = user.permissions;
    }

    hasPermission(permission: string): boolean {
        return this.permissions.some((permItem) => permItem === permission);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/models/user.model.ts